export const isNullOrEmpty = (value) => {
  if (value === '' || value === null || value === undefined) {
    return true;
  }
};

export const checkIfStringIsZeroOrEmpty = (value) => {
  if (value === 0) return value;
  else return value || '';
};
